// @flow

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2020 Adobe
*  All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/ 

export function genericAnalyticEvent(eventObject: Object) {
    const dataObject = {};

    // EVENT
    if (eventObject.event) {
        dataObject.setEventWorkflow = eventObject.event.workflow;
        dataObject.setEventSubcategory = eventObject.event.subcategory;
        dataObject.setEventType = eventObject.event.type;
        dataObject.setEventSubtype = eventObject.event.subtype;
        dataObject.setEventValue = eventObject.event.value;
        dataObject.setEventGUID = eventObject.event.guid;
        dataObject.setEventContextGUID = eventObject.event.context_guid;
    }

    // CONTENT
    if (eventObject.content) {
        dataObject.setContentID = eventObject.content.id;
        if (eventObject.content.name) {
            dataObject.setContentName = eventObject.content.name;
        }
        dataObject.setContentType = eventObject.content.type;
        dataObject.setContentCategory = eventObject.content.category;
        dataObject.setContentAction = eventObject.content.action;
        dataObject.setContentVersion = eventObject.content.version;
    }

    // UI
    if (eventObject.ui) {
        dataObject.setUISortOrder = eventObject.ui.sort_order;
    }

    return {
        format1: dataObject,
        format2: eventObject
    };
}